import { render, staticRenderFns } from "./ProductQueryLocation.vue?vue&type=template&id=525e3c6f&scoped=true"
import script from "./ProductQueryLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductQueryLocation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e3c6f",
  null
  
)

export default component.exports